import { ErrorPageProps } from "./error-page.props";
import { useErrorPageStyles } from "./error-page.styles";

export const ErrorPage = (props: ErrorPageProps) => {
  const classes = useErrorPageStyles();

  return (
    <>
      <h1 className={classes.title}>{props.title}</h1>
      {!!props.subTitle && <h2 className={classes.subTitle}>{props.subTitle}</h2>}
      {!!props.text && <p className={classes.text}>{props.text}</p>}
    </>
  );
};
